(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.dashboard-bid-table', [
    'pp.widgets-templates',
    'pp.controllers.dashboard-table',
    'pp.widgets.aum-dividend-notice'
]);

ngModule.component('ppDashboardBidTable', {
    templateUrl: 'widgets/_angular/dashboard-bid-table/dashboard-bid-table.tpl.html',
    bindings: {
        data: '<',
        openSidebarSymbol: '<',
        onChange: '&'
    },
    controllerAs: 'vm',
    controller: 'ppDashboardTableCtrl'
});
})(window, window.angular);